<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [errors]="question.errors"
  [css]="question.css"
  [key]="question.key"
  [value]="value"
  [dirty]="dirty"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>

<ion-list [formGroup]="formGroup">
  <ion-radio-group
    [formControlName]="question.key"
    [id]="question.key"
    allowEmptySelection="true"
    (ionChange)="onChange()"
  >
    <ion-item *ngFor="let opt of question.options">
      <ion-thumbnail *ngIf="opt.imageSrc"
        ><img [src]="opt.imageSrc"
      /></ion-thumbnail>
      <ion-radio
        mode="ios"
        [value]="opt.value"
        [attr.disabled]="question.disabled || question.readonly"
        [attr.aria-label]="opt.key"
        [class.bp-rtl]="document.dir === 'rtl'"
        labelPlacement="start"
        [style.marginLeft]="opt.imageSrc ? '16px' : '0'"
      >
        {{ opt.key }}
      </ion-radio>
    </ion-item>
  </ion-radio-group>
</ion-list>
